/**
 * Generated from Tim Wilden's Judge.me export.
 * Includes only verified, substantive reviews without an exclusion flag.
 * Regenerate after replacing the source CSV; do not edit this array by hand.
 */
window.MckReviewLibrary = [
  {
    "family": "PANTALONCINI",
    "subcategory": "Pantaloncini da trekking",
    "product": "Etna 2.6 Bermuda Trekking Donna",
    "handle": "etna-2-6-bermuda-trekking-donna",
    "url": "https://www.mckees.it/products/etna-2-6-bermuda-trekking-donna",
    "rating": 5,
    "author": "CRISTINA G.",
    "date": "2026-07-29",
    "verified": true,
    "text": "ottima qualità sia di prezzo che di materiale. azienda professionale puntuale",
    "productSeason": "estate",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Majella 2.6 Pantalone Estivo da Trekking Uomo",
    "handle": "majella-2-6-pantalone-estivo-da-trekking-uomo",
    "url": "https://www.mckees.it/products/majella-2-6-pantalone-estivo-da-trekking-uomo",
    "rating": 5,
    "author": "Roberto d.",
    "date": "2026-07-23",
    "verified": true,
    "text": "Ottimo capo pantaloni molto belli e di qualità Consiglio l'acquisto.",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "T-SHIRT / TOP",
    "subcategory": "T-Shirt",
    "product": "Longe 2.6 T-Shirt Uomo in Mesh",
    "handle": "longe-2-6-t-shirt-uomo-in-mesh",
    "url": "https://www.mckees.it/products/longe-2-6-t-shirt-uomo-in-mesh",
    "rating": 5,
    "author": "Giorgio G.",
    "date": "2026-07-13",
    "verified": true,
    "text": "ottimo prodotto , sicuramente ne comprero altre . tessuto leggero , elastico e molto confortevole",
    "productSeason": "estate",
    "textSeason": "neutro"
  },
  {
    "family": "T-SHIRT / TOP",
    "subcategory": "T-Shirt",
    "product": "Tarassaco 2.5 T-Shirt Uomo in Tessuto Tecnico",
    "handle": "tarassaco-2-5-t-shirt-uomo-in-tessuto-tecnico",
    "url": "https://www.mckees.it/products/tarassaco-2-5-t-shirt-uomo-in-tessuto-tecnico",
    "rating": 5,
    "author": "Ilario K.",
    "date": "2026-07-11",
    "verified": true,
    "text": "Tutto ok. T-shirt ottima",
    "productSeason": "estate",
    "textSeason": "neutro"
  },
  {
    "family": "ACCESSORI",
    "subcategory": "Zaini",
    "product": "Everest Zaino 50 Litri",
    "handle": "everest-zaino-50-litri",
    "url": "https://www.mckees.it/products/everest-zaino-50-litri",
    "rating": 5,
    "author": "RENATO V.",
    "date": "2026-06-27",
    "verified": true,
    "text": "Non l’ho ancora usato ma lo ritengo di ottima qualità e con gli spazi ben organizzati.",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "ACCESSORI",
    "subcategory": "Bastoncini da trekking",
    "product": "Bastoncini da Trekking Telescopici in Alluminio",
    "handle": "bastoncini-da-trekking-telescopici-in-alluminio",
    "url": "https://www.mckees.it/products/bastoncini-da-trekking-telescopici-in-alluminio",
    "rating": 1,
    "author": "Andrea M.",
    "date": "2026-06-26",
    "verified": true,
    "text": "Sì sono rotti con due uscite. Disastrosi!",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GILET",
    "subcategory": "Gilet",
    "product": "Callangate 2.6 Gilet Leggero Uomo",
    "handle": "callangate-2-6-gilet-leggero-uomo",
    "url": "https://www.mckees.it/products/callangate-2-6-gilet-leggero-uomo",
    "rating": 5,
    "author": "Paolo U.",
    "date": "2026-06-23",
    "verified": true,
    "text": "Gilet molto bello, leggero e di ottima vestibilità. Il rapporto materiale/qualità e prezzo secondo me è molto competitivo",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "ACCESSORI",
    "subcategory": "Zaini",
    "product": "Discovery Zaino 22 Litri",
    "handle": "discovery-zaino-22-litri",
    "url": "https://www.mckees.it/products/discovery-zaino-22-litri",
    "rating": 5,
    "author": "Anonimo",
    "date": "2026-06-22",
    "verified": true,
    "text": "Molto bello! Funzionale! Ottimo materiale! Leggero e versatile! Proprio quello che cercavo per le mie escursioni in montagna!",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "T-SHIRT / TOP",
    "subcategory": "T-Shirt",
    "product": "Axten 2.6 T-Shirt Uomo in Jaquard Waffle Mesh",
    "handle": "axten-2-6-t-shirt-uomo-in-jaquard-waffle-mesh-1",
    "url": "https://www.mckees.it/products/axten-2-6-t-shirt-uomo-in-jaquard-waffle-mesh-1",
    "rating": 5,
    "author": "Anonimo",
    "date": "2026-06-19",
    "verified": true,
    "text": "Ottimo prodotto di qualità",
    "productSeason": "estate",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche in Softshell",
    "product": "Bamus 2.6 Giacca Softshell Uomo",
    "handle": "bamus-giacca-softshell-uomo-cappuccio-mckees",
    "url": "https://www.mckees.it/products/bamus-giacca-softshell-uomo-cappuccio-mckees",
    "rating": 5,
    "author": "Gianfranco",
    "date": "2026-06-10",
    "verified": true,
    "text": "giacca con design ben curato, sportivo/elegante, la uso ovunque città/montagna, a paragonedi altri capi simili il prezzo l'ho trovato decisamente interessante",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "T-SHIRT / TOP",
    "subcategory": "T-Shirt",
    "product": "Darrot T-Shirt Uomo in drirelease®",
    "handle": "darrot-t-shirt-uomo",
    "url": "https://www.mckees.it/products/darrot-t-shirt-uomo",
    "rating": 5,
    "author": "Sandro B.",
    "date": "2026-06-09",
    "verified": true,
    "text": "Maglia leggerissima e comoda",
    "productSeason": "estate",
    "textSeason": "neutro"
  },
  {
    "family": "GILET",
    "subcategory": "Gilet ultralight",
    "product": "Antuco Gilet Ibrido Ultralight Uomo",
    "handle": "antuco-gilet-ibrido-ultralight-uomo",
    "url": "https://www.mckees.it/products/antuco-gilet-ibrido-ultralight-uomo",
    "rating": 5,
    "author": "Livio M.",
    "date": "2026-05-29",
    "verified": true,
    "text": "Ottimo capo, da utilizzare in mezza stagione, in caso di vento, molto leggero,",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche impermeabili",
    "product": "Brandon 2.6 Giacca a Guscio 4 Stagioni Uomo",
    "handle": "brandon-2-6-giacca-a-guscio-4-stagioni-uomo",
    "url": "https://www.mckees.it/products/brandon-2-6-giacca-a-guscio-4-stagioni-uomo",
    "rating": 3,
    "author": "Anonimo",
    "date": "2026-05-20",
    "verified": true,
    "text": "Buona giacca impermeabile, però e poco traspirabile",
    "productSeason": "tutto l'anno",
    "textSeason": "estate"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche in pile",
    "product": "Raissa 2.6 Giacca in Pile Donna",
    "handle": "raissa-2-6-giacca-in-pile-donna",
    "url": "https://www.mckees.it/products/raissa-2-6-giacca-in-pile-donna",
    "rating": 5,
    "author": "Anonimo",
    "date": "2026-05-14",
    "verified": true,
    "text": "Bellissimo capo ,morbido e di alta qualita,spedizione rapidissima !",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni",
    "product": "Drama – Pantalone Donna da Trail Running con Polsino",
    "handle": "drama-pantalone-con-polsino-donna",
    "url": "https://www.mckees.it/products/drama-pantalone-con-polsino-donna",
    "rating": 5,
    "author": "Annamaria",
    "date": "2026-05-12",
    "verified": true,
    "text": "Veste lievemente grande consiglio una taglia in meno, per il resto molto bello",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Arkell Pantalone Intermedio da Trekking Uomo con inserti in Cordura",
    "handle": "arkell-pantalone-intermedio-da-trekking-uomo-con-inserti-in-cordura",
    "url": "https://www.mckees.it/products/arkell-pantalone-intermedio-da-trekking-uomo-con-inserti-in-cordura",
    "rating": 4,
    "author": "Riccardo r.R.",
    "date": "2026-04-21",
    "verified": true,
    "text": "migliorare gli aspetti tecnici(+ tasche, un gancio) colori da aggiungere(verdone - grigio....) E' comunque un buon capo",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Hyder 2.6 Pile Uomo",
    "handle": "hyder-2-6-pile-uomo",
    "url": "https://www.mckees.it/products/hyder-2-6-pile-uomo",
    "rating": 3,
    "author": "Mauro C.",
    "date": "2026-04-07",
    "verified": true,
    "text": "Mi aspettavo meglio. Infatti ne avevo acquistato uno in un negozio fisico alcuni anni fa, ed era rifinito meglio (es. aveva un bordino sia inferiormente che ai polsi, bordino che questo nuovo non ha).",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "ACCESSORI",
    "subcategory": "Calzini",
    "product": "Even Calzino da Running Unisex",
    "handle": "even-calzino-da-running-unisex",
    "url": "https://www.mckees.it/products/even-calzino-da-running-unisex",
    "rating": 2,
    "author": "Maria C.",
    "date": "2026-03-31",
    "verified": true,
    "text": "Buona vestibilità Sensazione di protezione del piede Nessun attrito con la calzatura",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Latok Pile Uomo",
    "handle": "latok-pile-uomo",
    "url": "https://www.mckees.it/products/latok-pile-uomo",
    "rating": 5,
    "author": "LUCIANO C.",
    "date": "2026-03-24",
    "verified": true,
    "text": "Il pile veste bene ! La qualita' dei tessuti e' ottima!",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GILET",
    "subcategory": "Gilet",
    "product": "Denali 2.6 Gilet Uomo in Pile",
    "handle": "denali-2-6-gilet-uomo-in-pile",
    "url": "https://www.mckees.it/products/denali-2-6-gilet-uomo-in-pile",
    "rating": 5,
    "author": "Siro B.",
    "date": "2026-03-19",
    "verified": true,
    "text": "Pile morbido e confortevole. Vestibilità normale. Buon rapporto qualità/prezzo.",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Chachani Pantalone Estivo da Trekking Uomo con inserti in Cordura",
    "handle": "chachani-pantalone-estivo-da-trekking-uomo-con-inserti-in-cordura",
    "url": "https://www.mckees.it/products/chachani-pantalone-estivo-da-trekking-uomo-con-inserti-in-cordura",
    "rating": 4,
    "author": "Luciano",
    "date": "2026-03-19",
    "verified": true,
    "text": "Buona vestibilita' Buon rapporto qualità prezzo!",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "ACCESSORI",
    "subcategory": "Berretti",
    "product": "Willow Cappello Unisex Jaquard",
    "handle": "willow-cappello-unisex-jaquard",
    "url": "https://www.mckees.it/products/willow-cappello-unisex-jaquard",
    "rating": 5,
    "author": "Sonia S.",
    "date": "2026-03-16",
    "verified": true,
    "text": "Ottimo berretto, buona vestibilità e dei bei colori, molto soddisfatta",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Kristen – Pantalone Invernale da Trekking Donna Softshell con Inserti in Cordura",
    "handle": "kristen-pantalone-invernale-da-trekking-donna-con-inserti-in-cordura",
    "url": "https://www.mckees.it/products/kristen-pantalone-invernale-da-trekking-donna-con-inserti-in-cordura",
    "rating": 3,
    "author": "Fiora B.",
    "date": "2026-03-16",
    "verified": true,
    "text": "Un pò rigidi ma caldi.",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche in Softshell",
    "product": "Arlara 2.6 Donna Giacca in Softshell",
    "handle": "arlara-2-6-donna-giacca-in-softshell",
    "url": "https://www.mckees.it/products/arlara-2-6-donna-giacca-in-softshell",
    "rating": 5,
    "author": "Pina s.",
    "date": "2026-02-13",
    "verified": true,
    "text": "Arlara V2 Donna Giacca In Soft Shell",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "ACCESSORI",
    "subcategory": "Berretti",
    "product": "Valdez Cappello in Maglia Unisex",
    "handle": "valdez-cappello-in-maglia-unisex",
    "url": "https://www.mckees.it/products/valdez-cappello-in-maglia-unisex",
    "rating": 5,
    "author": "Rosalba",
    "date": "2026-02-12",
    "verified": true,
    "text": "Veramente comodo e bello",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Bend 2.6 Pile In Coral Fleece Uomo",
    "handle": "bend-2-6-pile-in-coral-fleece-uomo",
    "url": "https://www.mckees.it/products/bend-2-6-pile-in-coral-fleece-uomo",
    "rating": 5,
    "author": "Liborio P.",
    "date": "2026-02-08",
    "verified": true,
    "text": "Ottimo pile, vestibilità perfetta",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GILET",
    "subcategory": "Gilet ultralight",
    "product": "Ararat Gilet Imbottito Ultralight Uomo",
    "handle": "ararat-gilet-imbottito-ultralight-uomo",
    "url": "https://www.mckees.it/products/ararat-gilet-imbottito-ultralight-uomo",
    "rating": 5,
    "author": "ANNALISA F.",
    "date": "2026-02-03",
    "verified": true,
    "text": "Taglia perfetta, leggerissimo. Soddisfatta",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Hyder 2.6 Pile Uomo",
    "handle": "hyder-2-6-pile-uomo",
    "url": "https://www.mckees.it/products/hyder-2-6-pile-uomo",
    "rating": 5,
    "author": "Diego B.",
    "date": "2026-02-02",
    "verified": true,
    "text": "Ottimo come qualità. Preferirei che ci fosse anche una taglia in più. perché la L/XL non veste un 52 pieno anche per la lunghezza maniche",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Pordoi 2.6 Pantalone Invernale in Softshell da Trekking Uomo",
    "handle": "pordoi-2-6-pantalone-invernale-in-softshell-da-trekking-uomo",
    "url": "https://www.mckees.it/products/pordoi-2-6-pantalone-invernale-in-softshell-da-trekking-uomo",
    "rating": 5,
    "author": "Fabio a.",
    "date": "2026-01-28",
    "verified": true,
    "text": "Caldo e impermeabile , questo softshell è ottimo. Dovevo solo prendere la S ma non era piùdisponibile. Ma anche M mi vien bene è più comoda",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche in Softshell",
    "product": "Dry 2.6 Giacca Uomo in Softshell",
    "handle": "dry-2-6-giacca-uomo-in-softshell",
    "url": "https://www.mckees.it/products/dry-2-6-giacca-uomo-in-softshell",
    "rating": 5,
    "author": "Fabio a.",
    "date": "2026-01-28",
    "verified": true,
    "text": "Ottima giacca in shoft shell impermeabile e calda , purtroppo troppo aderente per mettere sotto altre cose.",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche in Softshell",
    "product": "Dry 2.6 Giacca Uomo in Softshell",
    "handle": "dry-2-6-giacca-uomo-in-softshell",
    "url": "https://www.mckees.it/products/dry-2-6-giacca-uomo-in-softshell",
    "rating": 5,
    "author": "Adelaide S.",
    "date": "2026-01-26",
    "verified": true,
    "text": "Bella , leggera, calda e confortevole",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Pordoi 2.6 Pantalone Invernale in Softshell da Trekking Uomo",
    "handle": "pordoi-2-6-pantalone-invernale-in-softshell-da-trekking-uomo",
    "url": "https://www.mckees.it/products/pordoi-2-6-pantalone-invernale-in-softshell-da-trekking-uomo",
    "rating": 5,
    "author": "massimiliano",
    "date": "2026-01-14",
    "verified": true,
    "text": "Ottimo prodotto qualità prezzo",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "ACCESSORI",
    "subcategory": "Bastoncini da trekking",
    "product": "Bastoncini da Trekking Telescopici in Carbonio",
    "handle": "bastoncini-da-trekking-telescopici-in-carbonio",
    "url": "https://www.mckees.it/products/bastoncini-da-trekking-telescopici-in-carbonio",
    "rating": 5,
    "author": "ANDREA N.",
    "date": "2026-01-04",
    "verified": true,
    "text": "Spero siano nuovamente disponibili per acquistare una seconda coppia",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Gilet in pile",
    "product": "Piz Boe Gilet Donna in Pile",
    "handle": "piz-boe-2-6-gilet-donna-in-pile",
    "url": "https://www.mckees.it/products/piz-boe-2-6-gilet-donna-in-pile",
    "rating": 4,
    "author": "Laura L.",
    "date": "2026-01-04",
    "verified": true,
    "text": "Ottimo prodotto,ne ho acquistato un secondo per regalare.",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Chachani Pantalone Estivo da Trekking Uomo con inserti in Cordura",
    "handle": "chachani-pantalone-estivo-da-trekking-uomo-con-inserti-in-cordura",
    "url": "https://www.mckees.it/products/chachani-pantalone-estivo-da-trekking-uomo-con-inserti-in-cordura",
    "rating": 5,
    "author": "Gaetano B.",
    "date": "2025-12-30",
    "verified": true,
    "text": "Ottimo prodotto, indossati per misurarli e calzano perfettamente. Appena le temperature lo permettono li testerò nelle mie escursioni.",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche in Softshell",
    "product": "Arlara 2.6 Donna Giacca in Softshell",
    "handle": "arlara-2-6-donna-giacca-in-softshell",
    "url": "https://www.mckees.it/products/arlara-2-6-donna-giacca-in-softshell",
    "rating": 4,
    "author": "Sonia L.",
    "date": "2025-12-25",
    "verified": true,
    "text": "Prodotto comodo e perfetto per lo sport all aperto. Lo uso per giocare a golf e consente di muoversi in libertà. Non vi ho dato 5 stelle solo per le finiture interne. Lo consiglierei",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche in Softshell",
    "product": "Dry 2.6 Giacca Uomo in Softshell",
    "handle": "dry-2-6-giacca-uomo-in-softshell",
    "url": "https://www.mckees.it/products/dry-2-6-giacca-uomo-in-softshell",
    "rating": 5,
    "author": "Anonimo",
    "date": "2025-12-25",
    "verified": true,
    "text": "Ottima vestibilita’ perfetto per il tempo libero",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Falzarego 2.6 – Pantalone Invernale da Trekking Donna in Softshell",
    "handle": "falzarego-2-6-pantalone-invernale-da-trekking-donna",
    "url": "https://www.mckees.it/products/falzarego-2-6-pantalone-invernale-da-trekking-donna",
    "rating": 5,
    "author": "Laura P.",
    "date": "2025-12-22",
    "verified": true,
    "text": "Pantaloni molto belli e molto caldi",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche in Softshell",
    "product": "Arlara 2.6 Donna Giacca in Softshell",
    "handle": "arlara-2-6-donna-giacca-in-softshell",
    "url": "https://www.mckees.it/products/arlara-2-6-donna-giacca-in-softshell",
    "rating": 5,
    "author": "Laura C.M.",
    "date": "2025-12-18",
    "verified": true,
    "text": "Arlara V2 Donna Giacca In Soft Shell",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Sattel 2.6 – Pantalone Intermedio Waterproof da Trekking Donna",
    "handle": "sattel-2-6-pantalone-intermedio-waterprooof-da-trekking-donna",
    "url": "https://www.mckees.it/products/sattel-2-6-pantalone-intermedio-waterprooof-da-trekking-donna",
    "rating": 5,
    "author": "Gaetano B.",
    "date": "2025-12-16",
    "verified": true,
    "text": "Sattel V2 Pantalone Waterprooof Trekking Donna",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Sattel 2.6 – Pantalone Intermedio Waterproof da Trekking Donna",
    "handle": "sattel-2-6-pantalone-intermedio-waterprooof-da-trekking-donna",
    "url": "https://www.mckees.it/products/sattel-2-6-pantalone-intermedio-waterprooof-da-trekking-donna",
    "rating": 5,
    "author": "Laura C.M.",
    "date": "2025-12-15",
    "verified": true,
    "text": "Sattel V2 Pantalone Waterprooof Trekking Donna",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONI",
    "subcategory": "Pantaloni da trekking",
    "product": "Eskil Pantalone Invernale da Trekking Uomo in Softshell con inserti in Cordura",
    "handle": "eskil-pantalone-invernale-da-trekking-uomo-in-softshell-con-inserti-in-cordura",
    "url": "https://www.mckees.it/products/eskil-pantalone-invernale-da-trekking-uomo-in-softshell-con-inserti-in-cordura",
    "rating": 5,
    "author": "Gaetano B.",
    "date": "2025-12-10",
    "verified": true,
    "text": "Ottimo prodotto, ho dovuto restituire il primo ordinato perché è risultato abbondante e ho subito ordinato la tg. 50 che è perfetta. Ho già testato in due uscite di 10 km con temperature 6/8 gradi ma possono performare anche con temperature negative: ne sono soddisfatto.",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Gilet in pile",
    "product": "Pelmo 2.6 Gilet Uomo in Pile",
    "handle": "pelmo-2-6-gilet-uomo-in-pile",
    "url": "https://www.mckees.it/products/pelmo-2-6-gilet-uomo-in-pile",
    "rating": 5,
    "author": "Marco C.",
    "date": "2025-12-09",
    "verified": true,
    "text": "Pelmo V2 Pile Smanicato Uomo",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "ACCESSORI",
    "subcategory": "Calzini",
    "product": "Magne Calzino Lungo Unisex",
    "handle": "magne-calzino-lungo-unisex",
    "url": "https://www.mckees.it/products/magne-calzino-lungo-unisex",
    "rating": 5,
    "author": "Carlos I.E.R.",
    "date": "2025-12-02",
    "verified": true,
    "text": "Super calentitos..y muy cómodos",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche in pile",
    "product": "Tolsona 2.6 Giacca Pile Donna",
    "handle": "tolsona-2-6-giacca-pile-donna",
    "url": "https://www.mckees.it/products/tolsona-2-6-giacca-pile-donna",
    "rating": 5,
    "author": "Daniela",
    "date": "2025-12-01",
    "verified": true,
    "text": "Semplice, ma caldo e confortevole!",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Arches 2.6 Pile Tecnico Uomo",
    "handle": "arches-2-6-pile-tecnico-uomo",
    "url": "https://www.mckees.it/products/arches-2-6-pile-tecnico-uomo",
    "rating": 5,
    "author": "Andrea B.",
    "date": "",
    "verified": true,
    "text": "Ottimo pile , fatto bene , inoltre è leggero e caldo. Già acquistato in precedenza in negozio nel colore blù e usato in montagna in estate nelle giornate più fredde",
    "productSeason": "tutto l'anno",
    "textSeason": "estate"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Aconcagua 2.6 Micropile Donna",
    "handle": "aconcagua-2-6-micropile-donna",
    "url": "https://www.mckees.it/products/aconcagua-2-6-micropile-donna",
    "rating": 5,
    "author": "Anonimo",
    "date": "",
    "verified": true,
    "text": "bellissima felpa ,leggera e calda ,bellissimo il colore ,la tg ho preso una m ed e perfetta per me che sono tra M ed L,spedizione rapidissima!",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Aconcagua 2.6 Micropile Donna",
    "handle": "aconcagua-2-6-micropile-donna",
    "url": "https://www.mckees.it/products/aconcagua-2-6-micropile-donna",
    "rating": 5,
    "author": "Vittoria",
    "date": "",
    "verified": true,
    "text": "Pienamente soddisfatta dell'acquisto.Il micropaile corrisponde alla mia richiesta e aspettative.La consegna è stata veloce.",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "T-SHIRT / TOP",
    "subcategory": "Canotte",
    "product": "Tronador 2.6 Canotta Uomo",
    "handle": "tronador-2-6-canotta-uomo",
    "url": "https://www.mckees.it/products/tronador-2-6-canotta-uomo",
    "rating": 5,
    "author": "Guido B.",
    "date": "",
    "verified": true,
    "text": "Molto confortevoli, sufficientemente traspiranti anche in questa estate super calda e facilissime da lavare.",
    "productSeason": "estate",
    "textSeason": "estate"
  },
  {
    "family": "PANTALONCINI",
    "subcategory": "Pantaloncini da trekking",
    "product": "Diran 2.6 Bermuda Trekking Uomo",
    "handle": "diran-2-6-bermuda-trekking-uomo",
    "url": "https://www.mckees.it/products/diran-2-6-bermuda-trekking-uomo",
    "rating": 5,
    "author": "Anonimo",
    "date": "",
    "verified": true,
    "text": "Professionalità e puntualità impeccabili ; Ottimi materiali e ottima vestibilità Completamente soddisfatta",
    "productSeason": "estate",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Aconcagua 2.6 Micropile Donna",
    "handle": "aconcagua-2-6-micropile-donna",
    "url": "https://www.mckees.it/products/aconcagua-2-6-micropile-donna",
    "rating": 5,
    "author": "Anonimo",
    "date": "",
    "verified": true,
    "text": "Micro pile fantastico ideale per le giornate fresche in montagna e in città’, veramente comodo",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Aconcagua 2.6 Micropile Donna",
    "handle": "aconcagua-2-6-micropile-donna",
    "url": "https://www.mckees.it/products/aconcagua-2-6-micropile-donna",
    "rating": 4,
    "author": "Anonimo",
    "date": "",
    "verified": true,
    "text": "Bella maglia tecnica, forse la misura è più abbondante di una L italiana",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche antivento",
    "product": "Attica 2.6 Giacca Donna a Guscio",
    "handle": "attica-giacca-donna-guscio-4-stagioni",
    "url": "https://www.mckees.it/products/attica-giacca-donna-guscio-4-stagioni",
    "rating": 5,
    "author": "Graziella B.",
    "date": "",
    "verified": true,
    "text": "Realmente impermeabile, leggera e comoda da indossare",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "GIACCHE",
    "subcategory": "Giacche impermeabili",
    "product": "Lavaredo 2.6 Giacca Antipioggia Comprimibile Uomo",
    "handle": "lavaredo-2-6-giacca-antipioggia-comprimibile-uomo",
    "url": "https://www.mckees.it/products/lavaredo-2-6-giacca-antipioggia-comprimibile-uomo",
    "rating": 4,
    "author": "LUCIANO C.",
    "date": "",
    "verified": true,
    "text": "Non l'ho ancora provata ma il prodotto sembra ottimo!",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Arches 2.6 Pile Tecnico Uomo",
    "handle": "arches-2-6-pile-tecnico-uomo",
    "url": "https://www.mckees.it/products/arches-2-6-pile-tecnico-uomo",
    "rating": 5,
    "author": "roberto a.",
    "date": "",
    "verified": true,
    "text": "Ottima qualità. Veste comodo. Pienamente soddisfatto",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Arches 2.6 Pile Tecnico Uomo",
    "handle": "arches-2-6-pile-tecnico-uomo",
    "url": "https://www.mckees.it/products/arches-2-6-pile-tecnico-uomo",
    "rating": 5,
    "author": "Simone S.",
    "date": "",
    "verified": true,
    "text": "ottimo pile , ottimo prezzo e transazione",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Arches 2.6 Pile Tecnico Uomo",
    "handle": "arches-2-6-pile-tecnico-uomo",
    "url": "https://www.mckees.it/products/arches-2-6-pile-tecnico-uomo",
    "rating": 4,
    "author": "Luca",
    "date": "",
    "verified": true,
    "text": "Pile molto bello e morbido. Top",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONCINI",
    "subcategory": "Pantaloncini",
    "product": "Ortica Pantaloncino Bambino Trekking Pull On",
    "handle": "ortica-pantaloncino-bambino-trekking-pull-on",
    "url": "https://www.mckees.it/products/ortica-pantaloncino-bambino-trekking-pull-on",
    "rating": 2,
    "author": "Francesca L.",
    "date": "",
    "verified": true,
    "text": "Mancano i bottoni Interni",
    "productSeason": "estate",
    "textSeason": "neutro"
  },
  {
    "family": "ACCESSORI",
    "subcategory": "Calzini",
    "product": "Helge Calzino Medio Unisex",
    "handle": "helge-calzino-medio-unisex",
    "url": "https://www.mckees.it/products/helge-calzino-medio-unisex",
    "rating": 5,
    "author": "Graziella B.",
    "date": "",
    "verified": true,
    "text": "Molto morbide e pratiche",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  },
  {
    "family": "PANTALONCINI",
    "subcategory": "Pantaloncini da trekking",
    "product": "Diran 2.6 Bermuda Trekking Uomo",
    "handle": "diran-2-6-bermuda-trekking-uomo",
    "url": "https://www.mckees.it/products/diran-2-6-bermuda-trekking-uomo",
    "rating": 5,
    "author": "Francesca A.",
    "date": "",
    "verified": true,
    "text": "Molto belli e leggeri",
    "productSeason": "estate",
    "textSeason": "neutro"
  },
  {
    "family": "PILE / MID-LAYER",
    "subcategory": "Pile e mid-layer",
    "product": "Arches 2.6 Pile Tecnico Uomo",
    "handle": "arches-2-6-pile-tecnico-uomo",
    "url": "https://www.mckees.it/products/arches-2-6-pile-tecnico-uomo",
    "rating": 5,
    "author": "Fabio a.",
    "date": "",
    "verified": true,
    "text": "Pile caldo e sottile.",
    "productSeason": "tutto l'anno",
    "textSeason": "neutro"
  }
];
